import { render, staticRenderFns } from "./totpCode.vue?vue&type=template&id=0779077e&scoped=true&"
import script from "./totpCode.vue?vue&type=script&lang=js&"
export * from "./totpCode.vue?vue&type=script&lang=js&"
import style0 from "./totpCode.vue?vue&type=style&index=0&id=0779077e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0779077e",
  null
  
)

export default component.exports